import * as yup from 'yup';

export default yup.array().of(yup.number()).min(2).max(2);
